module.exports = __webpack_public_path__ + "img/teclado_rog_strix.f16fd7e5.jpg";